import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'CoreVirtualDevicePacketVisualizations',
  props: {
    height: {
      type: Number,
      default: 300,
      required: false
    },
    data: {
      type: Object,
      required: false,
      default: null
    },
    parsedData: {
      type: [Object, String, Array],
      required: false,
      default: null
    },
    shouldShowParsedData: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      displayType: undefined
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'language'])), {}, {
    hasNoPacketData: function hasNoPacketData() {
      return this.data === null;
    }
  }),
  watch: {
    shouldShowParsedData: function shouldShowParsedData() {
      if (this.shouldShowParsedData) {
        this.displayType = 'parsed';
      }
    }
  },
  mounted: function mounted() {
    if (this.shouldShowParsedData) {
      this.displayType = 'parsed';
    }
  },
  methods: {
    noop: function noop() {
      alert('no operation');
    }
  }
};